import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  Typography
} from '@mui/material';

import CopyrightIcon from '@mui/icons-material/Copyright';
// import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link } from 'react-router';

const Footer = () => {

  const line_link = process.env.REACT_APP_LINE_LINK ?? ''
  const yt_link = process.env.REACT_APP_YT_LINK ?? ''

  return (
    <Card sx={{ bgcolor: '#f8fff0' }}>
      <CardContent>
        <Container maxWidth='lg'>
          <Grid container
            spacing={{ xs: 0.5, md: 2, lg: 4 }}
            sx={{
              justifyContent: 'center', alignItems: 'center',
              flexDirection: { xs: 'column-reverse', md: 'row' }
            }}
          >
            <Grid size={{ xs: 12, sm: 12, md: 3, lg: 'auto' }} sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
              <CopyrightIcon sx={{ color: 'primary.dark' }} />
              <Typography variant='body1' textAlign='center' color='primary.dark'>
                2026 蔣重點醫學快速搜尋系統 v0.1.0.9
              </Typography>
            </Grid>
            <Divider orientation='vertical' flexItem />
            <Grid size={{ xs: 12, sm: 12, md: 3, lg: 'auto' }} sx={{ display: { xs: 'none', md: 'block' } }}>
              <Typography variant='body1' textAlign='center' color='primary.dark'>
                本網站只知識分享，不做醫療建議
              </Typography>
            </Grid>
            <Divider orientation='vertical' flexItem />
            <Grid size={{ xs: 12, sm: 12, md: 'auto' }} sx={{
              display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {/* <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Some Line, come back in the future><Typography variant='body1'>@平安健康</Typography>
                </Box> */}
                <Link to={line_link} target='_blank' 
                  style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center'}}
                >
                  <Box
                    component='img'
                    src='/social/line_icon.png'
                    sx={{
                      height: '20px',
                    }}
                  />
                </Link>
                <Link to='tel:+886972931931'
                  style={{
                    textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '0.5rem'
                  }}
                >
                  <PhoneIcon sx={{ color: 'primary.dark' }} />
                  <Typography variant='body1' color='primary.dark'>0972-931-931</Typography>
                </Link>
              </Box>
              <Box>
                {/* <Link to='mailto:come back when email comes back'
                  style={{ textDecoration: 'none', color: 'inherit', display: 'flex', gap: '0.5rem' }}
                >
                  <EmailIcon /><Typography variant='body1'></Typography>
                </Link> */}
                <Link
                  to={yt_link} target='_blank'
                  style={{ textDecoration: 'none', color: 'inherit', display: 'flex', gap: '0.5rem' }}
                >
                  <YouTubeIcon sx={{ color: 'primary.dark' }} />
                  <Typography variant='body1' color='primary.dark'>平安健康SoSoSo</Typography>
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </CardContent>
    </Card>
  )
}

export default Footer;
